import Swiper from 'swiper';
import 'swiper/css';

export function initDivisionsSlider() {
    const sliderElements = document.querySelectorAll('.divisions-slider');
    
    sliderElements.forEach((sliderElement) => {
        let swiperInstance = null;
        
        const initSwiper = () => {
            if (window.innerWidth < 1024 && !swiperInstance) {
                swiperInstance = new Swiper(sliderElement, {
                    slidesPerView: 1.33,
                    spaceBetween: 16,
                    loop: false,
                });
            } else if (window.innerWidth >= 1024 && swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        };
        
        initSwiper();
        
        window.addEventListener('resize', initSwiper);
    });

    // Handle touch/click for mobile overlay toggle
    initDivisionOverlayToggle();
}

function initDivisionOverlayToggle() {
    const divisionItems = document.querySelectorAll('.js-division-item');
    
    divisionItems.forEach((item) => {
        const hasOverlay = item.dataset.hasOverlay === 'true';
        
        if (!hasOverlay) return;
        
        const overlay = item.querySelector('.js-division-overlay');
        const title = item.querySelector('.js-division-title');
        
        if (!overlay || !title) return;
        
        let isOpen = false;
        
        // Handle click/touch to toggle overlay
        item.addEventListener('click', (e) => {
            // Only handle on touch devices or smaller screens
            const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            
            if (isTouchDevice || window.innerWidth < 1024) {
                // Don't toggle if clicking a link inside the overlay
                if (isOpen && e.target.closest('a')) {
                    return;
                }
                
                e.preventDefault();
                isOpen = !isOpen;
                
                if (isOpen) {
                    overlay.classList.remove('translate-y-full', 'opacity-0');
                    overlay.classList.add('translate-y-0', 'opacity-100');
                    title.classList.add('opacity-0');
                } else {
                    overlay.classList.add('translate-y-full', 'opacity-0');
                    overlay.classList.remove('translate-y-0', 'opacity-100');
                    title.classList.remove('opacity-0');
                }
            }
        });
        
        // Close overlay when clicking outside on touch devices
        document.addEventListener('click', (e) => {
            const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            
            if ((isTouchDevice || window.innerWidth < 1024) && isOpen && !item.contains(e.target)) {
                isOpen = false;
                overlay.classList.add('translate-y-full', 'opacity-0');
                overlay.classList.remove('translate-y-0', 'opacity-100');
                title.classList.remove('opacity-0');
            }
        });
    });
}

